import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { throttle } from 'throttle-debounce';
import { THUMBNAIL_LIST_EARS } from '../../../../shared/constants';
import { getCoordinates, getNodeOffset, getUniversalPosition, toggleCursorStyles } from '../../../../shared/helpers';
import { isClick } from '../../../../shared/helpers/isClick';
import * as styles from './styles.css';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var Thumbnails = /*#__PURE__*/function (_React$Component) {
  function Thumbnails() {
    var _this;
    _classCallCheck(this, Thumbnails);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Thumbnails, [].concat(args));
    _defineProperty(_this, "elementListRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "elementListOffset", 0);
    _defineProperty(_this, "containerRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "lastCursorPosition", {
      x: 0,
      y: 0
    });
    _defineProperty(_this, "isScrolling", false);
    _defineProperty(_this, "handleMoveStart", function (e) {
      _this.toggleMove(true);
      _this.lastCursorPosition = getUniversalPosition(e.nativeEvent);
    });
    _defineProperty(_this, "handleResize", function () {
      _this.goToElement(_this.props.activeIndex);
    });
    _defineProperty(_this, "throttledHandleMoveStart", throttle(100, _this.handleMoveStart));
    _defineProperty(_this, "throttedResizeHandler", throttle(100, _this.handleResize));
    _defineProperty(_this, "handleMoveStartPersisted", function (e) {
      e.persist();
      _this.throttledHandleMoveStart(e);
    });
    _defineProperty(_this, "toggleMove", function (on) {
      var togglerFn = on ? window.addEventListener : window.removeEventListener;
      if (on) {
        _this.changeSlidesContainerTransition('none');
      }
      _this.isScrolling = on;
      toggleCursorStyles(on, _this.elementListRef);
      togglerFn('contextmenu', _this.handleMoveEnd);
      togglerFn('mouseup', _this.handleMoveEnd);
      togglerFn('touchend', _this.handleMoveEnd);
      togglerFn('mousemove', _this.handleMove);
      togglerFn('touchmove', _this.handleMove);
    });
    _defineProperty(_this, "changeSlidesContainerTransition", function (newValue) {
      _this.elementListRef.current.style.transition = newValue;
    });
    _defineProperty(_this, "handleMoveEnd", function (e) {
      if (!_this.isScrolling) {
        return;
      }
      var _getCoordinates = getCoordinates(e, _this.lastCursorPosition),
        deltaX = _getCoordinates.deltaX;
      _this.toggleMove(false);
      var shift = _this.getShift(deltaX);
      if (shift === Infinity) {
        _this.goToElement(_this.props.thumbnails.length - 1);
      } else if (shift === -Infinity) {
        _this.goToElement(0);
      } else {
        _this.setElementListOffset(shift, true);
      }
    });
    _defineProperty(_this, "handleMove", function (e) {
      var _getCoordinates2 = getCoordinates(e, _this.lastCursorPosition),
        deltaX = _getCoordinates2.deltaX;
      var shift = _this.getShift(deltaX, true);
      if (!_this.isScrolling || !isFinite(shift)) {
        return;
      }
      _this.setElementListOffset(shift);
    });
    _defineProperty(_this, "getShift", function (deltaX) {
      var withEars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var shift = _this.elementListOffset + -deltaX;
      var ear = withEars ? THUMBNAIL_LIST_EARS : 0;
      if (shift > ear) {
        return -Infinity;
      }
      if (-shift >= _this.elementListRef.current.offsetWidth - _this.containerRef.current.offsetWidth + ear) {
        return Infinity;
      }
      return shift;
    });
    _defineProperty(_this, "goToElement", function (index) {
      var max = _this.elementListRef.current.offsetWidth - _this.containerRef.current.offsetWidth;
      _this.changeSlidesContainerTransition("transform ease-in-out 150ms");
      var childNode = _this.elementListRef.current.childNodes[index];
      var offset = childNode ? getNodeOffset(childNode) : 0;
      var target = offset > max ? max : offset;
      _this.setElementListOffset(-target, true);
    });
    _defineProperty(_this, "setElementListOffset", function (shift) {
      var setOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (setOffset) {
        _this.elementListOffset = shift;
      }
      _this.elementListRef.current.style.transform = "translateX(".concat(shift, "px)");
    });
    _defineProperty(_this, "onThumbnailClick", function (index) {
      return function (e) {
        var currentPosition = getUniversalPosition(e.nativeEvent);
        if (!isClick(_this.lastCursorPosition, currentPosition)) {
          return;
        }
        _this.props.onThumbnailClick(index + 1);
      };
    });
    _defineProperty(_this, "updateElementListWidth", function () {
      var elementList = _this.elementListRef.current;
      var child = elementList === null || elementList === void 0 ? void 0 : elementList.childNodes[_this.props.thumbnails.length - 1];
      if (!elementList || !child) {
        return false;
      }
      var width = "".concat(getNodeOffset(child) + child.offsetWidth, "px");
      elementList.style.width = width;
      return width;
    });
    return _this;
  }
  _inherits(Thumbnails, _React$Component);
  return _createClass(Thumbnails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateElementListWidth();
      this.goToElement(this.props.activeIndex);
      window.addEventListener('resize', this.throttedResizeHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.throttedResizeHandler);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        activeIndex = _this$props.activeIndex,
        thumbnails = _this$props.thumbnails;
      if (thumbnails.length !== prevProps.thumbnails.length) {
        this.updateElementListWidth();
      }
      if (activeIndex !== prevProps.activeIndex) {
        this.goToElement(activeIndex);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        thumbnails = _this$props2.thumbnails,
        activeIndex = _this$props2.activeIndex;
      return /*#__PURE__*/_jsx("div", {
        className: styles['layout'],
        children: /*#__PURE__*/_jsx("div", {
          className: styles['container'],
          onMouseDown: this.handleMoveStartPersisted,
          onTouchStart: this.handleMoveStartPersisted,
          ref: this.containerRef,
          children: /*#__PURE__*/_jsx("div", {
            ref: this.elementListRef,
            className: styles['element_list'],
            children: thumbnails.map(function (node, index) {
              return /*#__PURE__*/_createElement("div", _objectSpread(_objectSpread({}, mergeStyles(styles['element'], activeIndex === index && styles['element--active'])), {}, {
                onClick: _this2.onThumbnailClick(index),
                key: index
              }), node);
            })
          })
        })
      });
    }
  }]);
}(React.Component);